<template>
  <div class="CSChatThai BGwhite">
    <v-toolbar style="background-color: white !important;">
      <v-btn icon @click="toPage('/listchat/')">
        <v-icon>chevron_left</v-icon>
      </v-btn>
      <h2>เพิ่มแอดมิน</h2>
    </v-toolbar>
    <v-layout column wrap>
      <v-tabs centered fixed-tabs style="height: 20px; margin-top: 0.9em;" icons-and-text>
        <v-tabs-slider color="blue"></v-tabs-slider>
          <v-tab href="#tab-1" :key="1">
            รายการแอดมิน
            <v-icon style="font-size: 25px !important;color: #2562af !important;">list</v-icon>
          </v-tab>
          <v-tab href="#tab-2" :key="2">
            เพิ่มแอดมิน
            <v-icon style="font-size: 25px !important;color: #2562af !important;">person_add</v-icon>
          </v-tab>
          <v-tabs-items v-model="tabs" class="white">
            <!-- tab friend -->
            <v-tab-item id="tab-1" style="height: calc(100vh - 128px);">
              <v-list two-line dense style="padding-top: 0px;">
                <!-- <v-container> -->
                <v-layout row wrap>
                  <v-flex xs1 xl1 md1 sm1 lg1>
                  </v-flex>
                  <v-flex xs10 xl10 md10 sm10 lg10 style="margin-top: 15px;">
                    <v-text-field append-icon="search" label="ค้นหาแอดมิน..." solo clearable v-model="search" style="color: white !important;"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs1 xl1 md1 sm1 lg1>
                  </v-flex>
                  <v-flex xs12 xl12 md12 sm12 lg12 class="scrolling-wrapper" style="height: calc(100vh - 280px);">
                    <!-- <b slot="header" class="CSChatThai" v-if="FilterFriendList.length != 0">รายการแอดมิน ({{FilterFriendList.length}})</b>
                    <b slot="header" class="CSChatThai" v-else>รายการแอดมิน</b> -->
                    <!-- web -->
                    <div v-if="!ProgressListFriend" class="hidden-sm-and-down">
                      <div style="background: #fff; max-height: 60vh;" class="scrolling-wrapper">
                        <v-layout row wrap align-center >
                          <v-flex sm4 md4 lg4 xl4  v-for="(item, index) in FilterOwnerList" :key="index">
                            <v-card class="fileCard" v-if="FilterOwnerList.length != 0" :key="item.tokenuser">
                              <div class="itemCard">
                                <v-avatar size="50">
                                  <img :src="item.profilepicture" class="alligator-turtle" v-if="item.profilepicture">
                                  <v-img :src="require('../../assets/robot1.png')"  class="alligator-turtle" v-else></v-img>
                                </v-avatar>
                                <v-card-text class="testCard">
                                  <p class="nameOwn">{{ item.name }}</p>
                                  <p class="statusOwn" v-if="item.status !== ''" style="margin-bottom:14px;">{{ item.status }}</p>
                                  <p v-else style="font-weight: normal;"> - </p>
                                </v-card-text>
                                <v-divider></v-divider>
                            <v-divider light></v-divider>
                              </div>
                              <v-flex style="background-color: #ab1700; color:white; cursor:pointer; margin-top:1 em;" v-on:click="removeowner(item)" :loading="loading" :disabled="loading" class="pa-3" v-if="item.tokenuser !== tokenuser">
                                <v-icon  dark small style="margin-right: 0.4em; font-size: 16px;">fas fa-minus-circle</v-icon>
                                ลบแอดมิน
                              </v-flex>
                              <v-flex v-else>
                                <img style="margin-top: 5px;" :src="require('../../assets/robot1.png')" height="40px">
                              </v-flex>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </div>
                    </div>
                    <!-- list mobile -->
                  <v-list class="hidden-md-and-up" subheader style="padding-left: 0px; padding-right: 0px; background-color: #fff !important; width: 100%;" v-if="!ProgressListFriend">
                    <template v-for="(item, index) in FilterOwnerList" >
                      <div avatar style="padding-top: 0px;" v-if="FilterOwnerList.length != 0" :key="item.tokenuser">
                        <v-list-tile avatar>
                          <v-list-tile-avatar style="padding-left: 1vw;margin-right: 1vw;">
                            <img v-if="item.profilepicture" :src="item.profilepicture" class="alligator-turtle" >
                            <img v-else :src="require('../../assets/robot1.png')" class="alligator-turtle">
                          </v-list-tile-avatar>

                          <v-list-tile-content style="margin-right: 0vw;padding-right: 1vw;">
                            <v-list-tile-title class="fontselect " style="font-size: 13px; width: 100px;">
                              {{item.name}}
                            </v-list-tile-title>
                            <v-list-tile-sub-title class="fontselectchat ">
                              <!-- <span class='text--primary fontselectchat ' v-if="item.status !== ''" style="font-size: 11px!important;">
                                {{item.status}}
                              </span> -->
                            </v-list-tile-sub-title>
                          </v-list-tile-content>
                          <v-list-tile-action v-if="item.tokenuser !== tokenuser">
                            <v-btn dark small v-on:click="removeowner(item)" :loading="loading" :disabled="loading" style="background-color: #ab1700 !important; padding-right: 10px; border-radius: 20px;">
                              <v-icon dark style="font-size: 16px; margin-right: 10px; margin-left: 10px;">far fa-trash-alt</v-icon>
                              ลบแอดมิน
                            </v-btn>
                          </v-list-tile-action>
                          <v-list-tile-action v-else>
                            <img :src="require('../../assets/robot1.png')" height="40px">
                          </v-list-tile-action>
                        </v-list-tile>
                      </div>
                      <v-divider v-if="index + 1 < FilterOwnerList.length" :key="`divider-${index}`"></v-divider>
                    </template>
                  </v-list>
                  <div v-else>
                    <v-progress-linear :indeterminate="ProgressListFriend"></v-progress-linear>
                  </div>
                  </v-flex>
                </v-layout>
                <!-- </v-container> -->
              </v-list>
            </v-tab-item>
            <!-- tab group -->
            <v-tab-item id="tab-2" style="height: calc(100vh - 128px);">
              <v-layout row wrap class="hidden-sm-and-down">
                <v-flex xs1 md1 sm1 lg1 xl1>
                </v-flex>
                <v-flex xs10 md10 sm10 lg10 xl10>
                  <v-layout row wrap justify-end align-end>
                    <v-chip class="mb-2 mt-3" label outline color="red">หมายเหตุ: สามารถเพิ่มแอดมินได้จากเพื่อนใน OneChat ของคุณเท่านั้น</v-chip>
                  </v-layout>
                </v-flex>
                <v-flex xs1 md1 sm1 lg1 xl1>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="hidden-md-and-up">
                <v-flex xs1 md1 sm1 lg1 xl1>
                </v-flex>
                <v-flex xs10 md10 sm10 lg10 xl10>
                  <v-layout row wrap justify-end align-end>
                    <v-layout justify-center align-center v-if="selectedfriend.length === 0" >
                      <v-btn disabled class="btncreategroup" small round>
                        เพิ่มแอดมิน
                      </v-btn>
                      <v-btn class="btncanclegroup" small round @click="closeSeleted()">
                        ยกเลิก
                      </v-btn>
                    </v-layout>
                    <v-layout justify-center align-center row wrap v-else>
                      <v-btn class="btncreategroup" small round @click="addowner()" :loading="loading" :disabled="loading">
                        เพิ่มแอดมิน
                      </v-btn>
                      <v-btn class="btncanclegroup" small round @click="closeSeleted()">
                        ยกเลิก
                      </v-btn>
                    </v-layout>
                    <v-dialog v-model="dialog" persistent max-width="290">
                      <template v-slot:activator="{ on }">
                        <v-btn flat icon color="red" v-on="on">
                          <v-icon>fas fa-question-circle</v-icon>
                        </v-btn>
                      </template>
                      <v-card>
                        <v-card-title class="headline">การเพิ่มแอดมิน</v-card-title>
                        <v-card-text>สามารถเพิ่มแอดมินได้จากเพื่อนใน OneChat ของคุณเท่านั้น</v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="primary" flat @click="dialog = false">ปิด</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-layout>
                </v-flex>
                <v-flex xs1 md1 sm1 lg1 xl1>
                </v-flex>
              </v-layout>
              <v-list dense style="padding-top: 0px;" class="listtap2">
                <!-- <v-container> -->
                <v-layout row wrap>
                  <v-flex xs1 xl1 md1 sm1 lg1>
                  </v-flex>
                  <v-flex xs10 xl10 md10 sm10 lg10 style="margin-top: 15px;">
                    <v-layout column wrap>
                      <v-text-field append-icon="search" label="ค้นหาเพื่อน..." solo clearable v-model="search" style="color: white !important;"
                      ></v-text-field>
                    </v-layout>
                  </v-flex>
                  <v-flex xs1 xl1 md1 sm1 lg1>
                  </v-flex>
                  <v-flex xs12 xl12 md12 sm12 lg12 class="scrolling-wrapper" style="height: calc(100vh - 280px);">
                    <!-- web -->
                    <div v-if="!ProgressListGroup" class="hidden-sm-and-down">
                      <div style="background: #fff; max-height: 50vh;" class="scrolling-wrapper">
                        <v-layout row wrap align-center>
                          <v-flex sm4 md4 lg4 xl4 v-for="(item, index) in FilterFriendList" :key="index">
                            <v-card class="fileCard2" v-if="FilterFriendList.length != 0" :key="item.tokenuser" @click.capture.stop="toggle(item.tokenuser)">
                              <v-checkbox style="margin-left: 10em; position: absolute" color="success" v-model="selectedfriend" :value="item.tokenuser" multiple></v-checkbox>
                              <div style="height: 150px;">
                                <v-avatar style="margin-top: 2em;" size="50">
                                  <v-img v-if="item.profilepicture" :src="item.profilepicture" class="alligator-turtle" ></v-img>
                                  <v-img v-else :src="require('../../assets/robot1.png')" class="alligator-turtle"></v-img>
                                </v-avatar>
                                <div style="margin-top:1em;">
                                  <p class="nameOwn">{{ item.name }}</p>
                                  <p class="statusOwn" v-if="item.status !== ''" style="margin-bottom:14px;">{{ item.status }}</p>
                                  <p v-else style="font-weight: normal;"> - </p>
                                </div>
                              </div>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </div>
                    </div>
                    <!-- mobile -->
                  <v-list class="hidden-md-and-up" dense subheader style="padding-left: 0px; padding-right: 0px; background-color: #fff !important; width: 100%; height: 220px;" v-if="!ProgressListGroup">
                    <template v-for="(item, index) in FilterFriendList" >
                      <div avatar style="padding-top: 0px;cursor: pointer;" v-if="FilterFriendList.length != 0" :key="item.tokenuser">
                        <v-list-tile avatar ripple :key="item.tokenuser" @click.capture.stop="toggle(item.tokenuser)">
                          <v-list-tile-avatar style="padding-left: 1vw;margin-right: 1vw;">
                            <img v-if="item.profilepicture" :src="item.profilepicture" class="alligator-turtle" >
                            <img v-else :src="require('../../assets/robot1.png')" class="alligator-turtle">
                          </v-list-tile-avatar>

                          <v-list-tile-content style="margin-right: 0vw;padding-right: 1vw;">
                            <v-list-tile-title class="fontselect " style="font-size:13px; width: 100px;">
                              {{item.name}}
                            </v-list-tile-title>
                            <v-list-tile-sub-title class="fontselectchat ">
                              <!-- <span class='text--primary fontselectchat ' v-if="item.status !== ''" style="font-size: 11px!important; width: 100px;">
                                {{item.status}}
                              </span> -->
                            </v-list-tile-sub-title>
                          </v-list-tile-content>
                          <v-list-tile-action >
                            <v-checkbox v-model="selectedfriend" :value="item.tokenuser" multiple></v-checkbox>
                          </v-list-tile-action>
                        </v-list-tile>
                      </div>
                      <v-divider v-if="index + 1 < FilterFriendList.length" :key="`divider-${index}`"></v-divider>
                    </template>
                  </v-list>
                  <div v-else>
                    <v-progress-linear :indeterminate="ProgressListGroup"></v-progress-linear>
                  </div>
                  </v-flex>
                  <v-flex class="hidden-sm-and-down" xs12 sm12 md12 style="margin-top: 0.5em; margin-bottom: 1em; background-color: white;" >
                    <v-layout justify-center align-center v-if="selectedfriend.length === 0" >
                      <v-btn disabled class="btncreategroup" small round>
                        เพิ่มแอดมิน
                      </v-btn>
                      <v-btn class="btncanclegroup" small round @click="closeSeleted()">
                        ยกเลิก
                      </v-btn>
                    </v-layout>
                    <v-layout justify-center align-center row wrap v-else>
                      <v-btn class="btncreategroup" small round @click="addowner()" :loading="loading" :disabled="loading">
                        เพิ่มแอดมิน
                      </v-btn>
                      <v-btn class="btncanclegroup" small round @click="closeSeleted()">
                        ยกเลิก
                      </v-btn>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <!-- </v-container> -->
              </v-list>
              <!-- <div class="footer" style="position: relative; top: 400px;" center>
                <v-flex xs12 sm12 md12 >
                  <v-layout justify-center align-center row wrap v-if="selectedfriend.length === 0" >
                    <v-btn disabled class="btncreategroup" small round>
                      เพิ่มแอดมิน
                    </v-btn>
                    <v-btn class="btncanclegroup" small round @click="closeSeleted()">
                      ยกเลิก
                    </v-btn>
                  </v-layout>
                  <v-layout justify-center align-center row wrap v-else>
                    <v-btn class="btncreategroup" small round @click="addowner()" :loading="loading" :disabled="loading">
                      เพิ่มแอดมิน
                    </v-btn>
                    <v-btn class="btncanclegroup" small round @click="closeSeleted()">
                      ยกเลิก
                    </v-btn>
                  </v-layout>
                </v-flex>
              </div> -->
            </v-tab-item>
          </v-tabs-items>
      </v-tabs>
  </v-layout>
  </div>
</template>
<script>
import { Decode } from '@/services'
var _ = require('lodash')
export default {
  components: {
  },
  data: () => ({
    dialog: false,
    ProgressListFriend: false,
    ProgressListGroup: false,
    selectedfriend: [],
    isLoading: false,
    loading: false,
    tabs: 'tab-1',
    tokenservice: '',
    listfriend: [],
    listownerbot: [],
    progress: false,
    search: '',
    tokenuser: ''
  }),
  computed: {
    FilterFriendList () {
      if (this.search !== '' && this.search !== null) {
        return this.listfriend.filter(post => {
          return post.name.toLowerCase().includes(this.search.toLowerCase())
        })
      } else {
        return this.listfriend
      }
    },
    FilterOwnerList () {
      if (this.search !== '' && this.search !== null) {
        return this.listownerbot.filter(post => {
          return post.name.toLowerCase().includes(this.search.toLowerCase())
        })
      } else {
        return this.listownerbot
      }
    }
  },
  watch: {
    '$route.params.id' () {
      this.getlistfrienuser()
      this.getlistownerbot()
    },
    selectedfriend () {
      // console.log(this.selectedfriend)
    }
  },
  created () {
    this.tokenuser = Decode.decodeToken(localStorage.getItem('tokenuser'))
    this.tokenservice = 'Bearer ' + Decode.decodeToken(localStorage.getItem('tokenservice'))
    this.getlistfrienuser()
    this.getlistownerbot()
  },
  methods: {
    toggle (item) {
      if (this.selectedfriend.includes(item)) {
        // Removing the item
        this.selectedfriend.splice(this.selectedfriend.indexOf(item), 1)
      } else {
        this.selectedfriend.push(item)
      }
    },
    closeSeleted () {
      this.selectedfriend = []
    },
    addowner () {
      this.loading = true
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/addbotowner', { tokenbot: this.$route.params.id, tokenuser: this.tokenuser, list_new_owner: this.selectedfriend }).then((response) => {
        if (response.data.status === 'success') {
          this.$swal({ title: 'เพิ่มแอดมินสำเร็จ', type: 'success' })
          this.closeSeleted()
          this.loading = false
          this.getlistfrienuser()
          this.getlistownerbot()
        } else {
          this.$swal({ title: 'ไม่สามารถเพิ่มแอดมินได้!', type: 'warning' })
          this.closeSeleted()
          this.loading = false
        }
      })
    },
    removeowner (item) {
      this.$swal({
        title: 'ยืนยันการลบแอดมิน',
        text: 'คุณต้องการลบแอดมิน ' + item.name + ' ใช่หรือไม่?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          this.axios.post(process.env.VUE_APP_API_MANAGE + '/removebotowner', { tokenbot: this.$route.params.id, tokenuser: this.tokenuser, token_remove_owner: item.tokenuser }).then((response) => {
            if (response.data.status === 'success') {
              this.$swal({ title: 'ลบแอดมินสำเร็จ', type: 'success' })
              this.listownerbot.splice(_.findIndex(this.listownerbot, function (o) { return o.tokenuser === item.tokenuser }), 1)
              this.getlistfrienuser()
              this.loading = false
            } else {
              this.$swal({ title: 'ไม่สามารถลบแอดมินได้!', type: 'warning' })
              this.closeSeleted()
              this.loading = false
            }
          })
        }
      })
    },
    getlistfrienuser () {
      this.ProgressListFriend = true
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/web/getlistfriend', { tokenuser: this.tokenuser }).then((response) => {
        if (response.data.status === 'success') {
          this.listfriend = response.data.listfriend
          this.listfriend = _.filter(this.listfriend, function (listfriend) { return listfriend.type === 'user' })
          this.listfriend = _.differenceBy(this.listfriend, this.listownerbot, 'tokenuser')
          this.ProgressListFriend = false
        } else {
          this.ProgressListFriend = true
        }
      })
    },
    getlistownerbot () {
      this.ProgressListGroup = true
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/getbotowner', { bot_id: this.$route.params.id }).then((response) => {
        if (response.data.status === 'success') {
          this.listownerbot = response.data.bot_owner
          this.listownerbot = _.unionBy(this.listownerbot, response.data.bot_owner, 'tokenuser')
          this.ProgressListGroup = false
        } else {
          this.ProgressListGroup = true
        }
      })
    },
    toPage (data) {
      // console.log(data)
      this.$router.push(data + this.$route.params.id)
    }
  }
}
</script>
<style type="text/css" scoped>
.btncreategroup {
  color: white !important;
  background-color: #3ea36c !important;
}
.btncanclegroup {
  color: #1b232db3 !important;
  background-color: #cacacae3 !important;
}
.footer {
  border-width: thin;
  border-top-style: solid;
  border-color: #80808099;
  height: 40px;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: #ffffff;
  color: #c8c8c8c9;
  text-align: center;
}
.listtap2 {
  height:500px;/* or any height you want */
  /* overflow-y:auto */
}
>>>.v-tabs__container--icons-and-text {
  height: 50px !important;
}
.text2 {
  white-space: nowrap;
  width: 155px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.borderfile {
  border: 1px solid #00000036;
  border-radius: 5px;
  width: 300px !important;
  height: 185px !important;
  position: relative;
  background: white;
}
.containers {
  width: 576px; margin: 0 auto;
}

.containers:after {
  content: '';
  display: block;
  clear: both;
}

[class*='close-'] {
  color: #777;
  font: 27px/100% arial, sans-serif;
  position: absolute;
  right: 15px;
  text-decoration: none;
  text-shadow: 0 1px 0 #fff;
  top: 5px;
}
.close-classic:after {
  content: '×'; /* ANSI X letter */
}
.buttonsubmit {
  background-color: #2562af !important;
  border-radius: 8px !important;
  color: white !important;
  text-transform: none !important;
}
.buttoncancel {
  border-radius: 8px !important;
  color: #4c4c4c !important;
  text-transform: none !important;
  border-color: #8080807d !important;
  border-style: solid !important;
  border-width: thin !important;
}
.fontchat {
  color: gray;
  font-size: 12px;
}
.leftbox {
  height: calc(100vh - 64px);
  background-color: #fff !important;
  overflow: hidden;
}
>>>.v-input__slot {
  width: 100%;
  border-radius: 20px;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  /*height: 100px !important;*/
  border-radius: 20px !important;
  width: 100% !important;
  border-style: solid !important;
  border-color: #c1c1c1 !important;
  box-shadow: none !important;
  border-width: thin !important;
}
.scrolling-wrapper {
  /*display: flex;*/
  overflow-y: auto;
  /* max-height: calc(100vh - 280px); */
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 4px;
  width: 8px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(0, 0, 0, .1);
}
.alligator-turtle {
  object-fit: cover;
  object-position: 50% 0;
}
.testCard {
  padding: 16px;
  padding-top: 16px;
  padding-right: 16px;
  padding-bottom: 0px;
  padding-left: 16px;
  width: 100%;
}
/* >>>.v-card__text {
  padding: 16px;
  padding-top: 16px;
  padding-right: 16px;
  padding-bottom: 0px;
  padding-left: 16px;
  width: 100%;
} */
.fileCard {
  margin-bottom: 20%;
  width:200px;
  height:200px;
  margin-bottom:30px;
  display:inline-block;
}
.fileCard2 {
  margin-bottom: 20%;
  width:200px;
  height:150px;
  margin-bottom:30px;
  display:inline-block;
  cursor: pointer;
}
.itemCard{
  padding-top: 10%;
}
>>>.theme--light .v-card.fileCard {
  border: 2px solid rgba(0,0,0,0.12) !important;
  border-radius: 10px;
}
>>>.theme--light .v-card.fileCard2 {
  border: 2px solid rgba(0,0,0,0.12) !important;
  border-radius: 10px;
}
.nameOwn{
  margin-left:auto;
  margin-right:auto;
  font-weight: bold;
  color: black !important;
  white-space: nowrap;
  width: 10em;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom:2px;
}
.statusOwn{
  margin-left:auto;
  margin-right:auto;
  color: black !important;
  font-weight: normal;
  white-space: nowrap;
  width: 10em;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom:2px;
}
>>>.v-input--selection-controls {
  margin-top: 4px;
}
</style>
